import { Routes } from "@angular/router";
import { baseRoutes } from "./base-routes";

export const routes: Routes = baseRoutes